module.exports = {
    "Empty": `Gol`
};


//# sourceMappingURL=ro-RO.main.js.map
